import { Component, Inject, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { take } from "rxjs";
import { EvaluatorService } from "src/app/core/services/evaluator.service";

@Component({
  selector: "app-file-details",
  templateUrl: "./file-details.component.html",
  styleUrls: ["./file-details.component.scss"],
})
export class FileDetailsComponent implements OnInit {
  images: string[] = [];

  reviewControl = new FormControl();
  remarksControl = new FormControl();
  xrayDiagnosis = new FormControl();
  selectedXrayType = new FormControl();

  public xraySubConditions
  public xrayConditions

  isLoading: boolean = false;

  slideConfig = {
    slideToShow: 4,
    pauseOnHover: true,
    autoplay: false,
  };
  constructor(
    private dialogRef: MatDialogRef<FileDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private evaluatorService: EvaluatorService
  ) { }

  ngOnInit() {
    this.evaluatorService.getXrayTypes().subscribe((res) => {
      let xraySelector
      this.xrayConditions = res
      if (this.data.application.applicationXRayDiagnoses.length > 0) {
        setTimeout(() => {
          this.selectedXrayType.patchValue(this.data.application.applicationXRayDiagnoses.at(-1).xRayDiagnosisId)
        }, 500)
      }
      this.selectedXrayType.valueChanges.subscribe(res => {
        xraySelector = res
        this.xraySubConditions = this.xrayConditions.filter(x => x.id == xraySelector)[0].subconditions
      })
    })

    for (const item of this.data.file.fileDetails) {
      this.images.push(item.fullPath);
    }
  }

  onReview() {
    this.isLoading = true;
    const body = {
      status: this.reviewControl.value,
      remark: this.remarksControl.value ? this.remarksControl.value : "",
    };

    this.evaluatorService
      .fileReview(body, this.data.application.id, this.data.file.id)
      .subscribe((res) => {
        if (this.data.file.resultTypeValue == 2) {
          const body = {
            applicationId: this.data.application.id,
            xRayDiagnosisId: '',
            xRaySubconditionId: this.xrayDiagnosis.value,
            additionalInformation: '',
          }
          if (this.data.application.applicationXRayDiagnoses.lenght > 0) {
            body.xRayDiagnosisId = this.data.application.applicationXRayDiagnoses.at(-1).xRayDiagnosisId
          } else {
            body.xRayDiagnosisId = this.selectedXrayType.value
          }
          this.evaluatorService.addXrayDiagnosis(body).pipe(take(1)).subscribe(res => {
            const body = {
              status: this.reviewControl.value,
              remark: this.xraySubConditions.filter(x => x.id == this.xrayDiagnosis.value)[0].name,
            };
            this.evaluatorService
              .fileReview(body, this.data.application.id, this.data.file.id)
              .subscribe((res) => { })
          })
        }

        this.isLoading = false;
        this.dialogRef.close();
      });
  }

  isImage(filePath: string): boolean {
    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
    return allowedExtensions.test(filePath);
  }
}
